export default "__VITE_ASSET__BZBU2pt1__"